export default {
  data() {
    return {
      editDialog: false,
      editedItem: {},
    };
  },
  methods: {
    onEdit(e) {
      this.editedItem = e;
      this.editDialog = true;
    },
    onUpdate(e) {
      for (let index = 0; index < this.$refs.crud.$refs.pag.data.results.length; index++) {
        const element = this.$refs.crud.$refs.pag.data.results[index];
        if (element.uuid === e.uuid) {
          element.name = e.name;
          if (e.image) {
            element.image = e.image;
          }
        }
      }
    },
  },
};
